export const BULK_MAPPING_FIELDS = [
  {
    key: 'title',
    label: 'Product Title',
    required: true,
    helper:
      'What your buyers see. Must not be empty. Maximum 500 characters. Examples: "Ribeye Steak", "Chicken Breast 500g"',
  },
  {
    key: 'sku',
    label: 'SKU / Product Code',
    required: true,
    helper:
      'Used to match existing products (case-insensitive). Must not be empty. Maximum 100 characters. Examples: "RIB01", "CHK-BREAST-500". Note: "abc" will match "ABC"',
  },
  {
    key: 'size',
    label: 'Size',
    required: true,
    helper:
      'Pack size description. Must not be empty. Examples: "1x1kg", "10 x 200g", "1 x 2.5kg", "24x100gr"',
  },
  {
    key: 'price',
    label: 'Customer Price',
    required: true,
    helper:
      'Must be a number only (no currency symbols). Cannot be negative or text. Examples: 25.50, 100, 12.99. Invalid: "£25", "Tbc", "N/A"',
  },
  {
    key: 'type',
    label: 'Type',
    required: true,
    helper:
      'Product category. Must not be empty. Examples: "Meat & Poultry", "Beef", "Steaks", "Game", "Sausages & Breakfast"',
  },
  {
    key: 'hasVat',
    label: 'Has VAT',
    required: true,
    helper:
      'Must be: Yes/No, True/False, or 1/0 (case-insensitive). Examples: "Yes", "TRUE", "1", "No", "FALSE", "0"',
  },
  {
    key: 'UoM',
    label: 'Unit of Measure',
    required: false,
    helper:
      'Optional: Unit of measurement. Common values: "Kg", "Each", "Pack", "Box", "g", "L", "ml". Leave blank if not applicable.',
  },
  {
    key: 'pricedBy',
    label: 'Priced By',
    required: false,
    helper:
      'Optional: Overrides UoM if you price differently. Examples: "Weight", "Volume", "Count". Leave blank if not needed.',
  },
  {
    key: 'GLN',
    label: 'GLN',
    required: false,
    helper:
      'Optional: Global Location Number. Must be numeric if provided (max 20 digits). Examples: "1234567890123", "0". Leave blank if not applicable.',
  },
  {
    key: 'cloudinaryImageId',
    label: 'Image URL / ID',
    required: false,
    helper:
      'Optional: Must be a valid HTTP/HTTPS URL or Cloudinary ID if provided. Examples: "https://example.com/image.jpg" or "products/meat/steak". Leave blank if no image.',
  },
]

export const REQUIRED_BULK_MAPPING_FIELD_KEYS = BULK_MAPPING_FIELDS.filter(
  field => field.required,
).map(field => field.key)

export const createEmptyBulkFieldMapping = () =>
  BULK_MAPPING_FIELDS.reduce((acc, field) => {
    acc[field.key] = ''
    return acc
  }, {})
